import React from "react"

import { AppFuelPolicyAutocomplete } from "@components/Autocomplete"


export default function FuelPolicyAutocomplete({ ...props }) {
	
    return <AppFuelPolicyAutocomplete {...props}/>
}